export const subscriptionStatusesMeta = {
    trialing: {
        label: "En prueba",
        class: "bg-theme-info text-white"
    },
    active: {
        label: "Activo",
        class: "bg-theme-success text-white"
    },
    past_due: {
        label: "En gracia",
        class: "bg-theme-warning text-black"
    },
    scheduled: {
        label: "Programado",
        class: "bg-theme-info text-white"
    },
    canceled: {
        label: "Terminado",
        class: "bg-theme-muted text-theme-inverse"
    }
};

export const noSubscriptionLabel = "Sin suscripción";

export const subscriptionStatusFilterCodes = {
    ...Object.fromEntries(
        ["trialing", "active", "past_due"].map((status) => [
            status,
            subscriptionStatusesMeta[status].label
        ])
    ),
    none: noSubscriptionLabel
};

export const planCodes = {
    free: "Free",
    starter: "Starter",
    pro: "Pro",
    premium: "Premium"
};

export const subscriptionTypesCodes = {
    trial: "Prueba",
    paid: "Pago",
    free: "Free"
};

export const lastInvoiceStatusesCodes = {
    pending: "Pendiente",
    overdue: "Vencida"
};
